@if (isDefault) {
  <pr-input-abstract
    [control]="control"
    [derrors]="derrors"
    [label]="label"
    [tooltipButton]="tooltipButton"
    class="pr-input-radio"
  >
    @for (option of options; track option; let last = $last) {
      <label
        [attr.checked]="checked(option)"
        [attr.disabled]="disable"
        [for]="formLabel + '_' + option?.value"
        [ngClass]="{
          'label-toggle': toggle,
          'label-toggle-bg-empty': toggleBgEmpty,
        }"
        [ngStyle]="{
          'margin-right': toggle || toggleBgEmpty || last ? '0' : '8px',
        }"
      >
        <input
          #input
          (change)="onInputChange(option)"
          [(ngModel)]="control.value"
          [disabled]="disable"
          [id]="formLabel + '_' + option?.value"
          [name]="formLabel + '_' + option?.value"
          type="radio"
        />
        <div>
          @if (option.icon) {
            <pr-icon [name]="option.icon" style="float: left"></pr-icon>
          }
          {{ option?.label }}
        </div>
      </label>
    }
  </pr-input-abstract>
} @else {
  <div
    [ngStyle]="{
      margin: '0',
      padding: '0',
      border: derrors && control.errors ? '1px solid rgb(160, 13, 13)' : 'none',
    }"
  >
    <pr-input-abstract
      [control]="control"
      [derrors]="derrors"
      [isDefault]="isDefault"
      [label]="label"
      class="pr-input-radio"
    >
      <div
        [ngStyle]="{
          'grid-gap': toggle ? '0' : '20px',
        }"
        class="grid grid-col-{{ columns }} "
      >
        @for (option of options; track option) {
          <label
            [attr.checked]="checked(option)"
            [attr.disabled]="disable"
            [for]="formLabel + '_' + option?.value"
            [ngClass]="{
              'label-toggle': toggle,
              'label-toggle-bg-empty': toggleBgEmpty,
            }"
            [ngStyle]="{
              'margin-right': toggle || toggleBgEmpty ? '0' : '8px',
            }"
            class="label-state"
          >
            <input
              #input
              (change)="onInputChange(option)"
              [(ngModel)]="control.value"
              [disabled]="disable"
              [id]="formLabel + '_' + option?.value"
              [name]="formLabel + '_' + option?.value"
              type="radio"
            />
            <div class="prefix">
              @if (option.icon) {
                <pr-icon [name]="option.icon" style="float: left"></pr-icon>
              }
              @if (option.suffix) {
                <pr-suffix [suffix]="option.suffix"></pr-suffix>
              }
              {{ option?.label }}
              @if (option.prefix) {
                <span
                  [ngStyle]="{
                    display: 'flex',
                    padding: '4px 8px',
                    'border-radius': '4px',
                    'text-align': 'center',
                    'margin-left': '8px',
                    color: option?.prefix?.color,
                    'background-color': option?.prefix?.backgroundColor,
                    'font-family': 'Inter',
                    'font-size': '12px',
                    'font-style': 'normal',
                    'font-weight': '600',
                  }"
                  >{{ option?.prefix?.title }}</span
                >
              }
            </div>
          </label>
        }
        <ng-content></ng-content>
      </div>
    </pr-input-abstract>
  </div>
}
